import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Input, Select, Divider, Table, Button, Form, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { getPharmacyId } from '../../components/Shared';
import { sendData } from '../../httpRequests';
import { collection, query, where, onSnapshot, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';

const { Search } = Input;
const { Option } = Select;

export default function Drivers() {
	const navigate = useNavigate();
	const [drivers, setDrivers] = useState([]);
	const [filteredDrivers, setFilteredDrivers] = useState([]);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		const pharmacyId = localStorage.getItem("PHARMACY_LOGGED")
		loadDrivers();
		NuevaPrueba(pharmacyId)
	}, []);

	const NuevaPrueba = (pharmacyId) => {
		const q = query(collection(db, 'driveActive'), where('pharmacy_id', '==', Number(localStorage.getItem('PHARMACY_LOGGED'))));
		onSnapshot(q, (querySnapshot) => {
			loadDrivers();
			console.log("Dios", querySnapshot.docChanges())
		})
	}

	const loadDrivers = () => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		const url = '/user/getDriverByPharmacy';
		const data = {
			pharmacy_id: pharmacyId
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				const drivers = response['driver'];
				setDrivers(drivers);
				setFilteredDrivers(drivers);
			}
		});
	};

	const onSearch = (value) => {
		const text = value.target.value.toLowerCase();
		setTimeout(() => {
			if (text) {
				const filteredDrivers = drivers.filter((driver) => driver.email.toLowerCase().includes(text));
				setFilteredDrivers(filteredDrivers);
			} else {
				setFilteredDrivers(drivers);
			}
		}, 1000);
	};

	const handleChangeStatus = (value) => {
		if (value) {
			const filteredDrivers = drivers.filter((driver) => driver.active == value);
			setFilteredDrivers(filteredDrivers);
		} else {
			setFilteredDrivers(drivers);
		}
	};

	const openDriverModal = (driver) => {
		setShowModal(true);
	};

	const closeDriverModal = () => {
		setShowModal(false);
		loadDrivers();
	};

	const columns = [
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email'
		},
		{
			title: 'Full name',
			dataIndex: 'first_name',
			defaultSortOrder: 'ascend',
			sorter: (a, b) => a.first_name.localeCompare(b.first_name)
		},
		{
			title: 'Zip code',
			dataIndex: 'zip_code'
		},
		{
			title: 'Status',
			render: ({ active }) => (
				<div>
					{
						(active == true)
							? <div >


								<div style={{ display: 'flex', alignItems: 'baseline' }}>
									<div style={{ marginRight: '10px' }}>Online</div>
									<div className='online'></div>
								</div>
							</div>

							: <div>

								<div style={{ display: 'flex', alignItems: 'baseline' }}>
									<div style={{ marginRight: '10px' }}>Offline</div>
									<div className='offline'></div>
								</div>
							</div>
					}
				</div>
			)
		}
	];

	return (
		<div>
			<DriverModal showModal={showModal} closeDriverModal={closeDriverModal} />
			<Row gutter={24}>
				<Col span={8}>
					<Search size='large' placeholder='Search driver by email' onChange={onSearch} />
				</Col>
				<Col span={8}>
					<Select
						placeholder='Select status'
						defaultValue={''}
						size='large'
						onChange={handleChangeStatus}
						style={{ width: '100%' }}
					>
						<Option value=''>All</Option>
						<Option value='1'>Online</Option>
						<Option value='2'>Offline</Option>
					</Select>
				</Col>
				<Col span={8}>
					<Button
						onClick={() => openDriverModal()}
						type='primary'
						size='large'
						style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
					>
						<PlusOutlined />
						Add Driver
					</Button>
				</Col>
			</Row>
			<Divider />
			<Row gutter={24}>
				<Col span={24}>
					<Table
						columns={columns}
						dataSource={filteredDrivers}
						rowKey={(item) => item.id}
						onRow={(record) => {
							return {
								onClick: () => navigate('/driverDetails/' + record.id)
							};
						}}
					/>
				</Col>
			</Row>
		</div>
	);
}

function DriverModal({ showModal, closeDriverModal }) {
	const form = useRef(null);

	const handleSubmit = (values) => {
		const pharmacyId = getPharmacyId();
		if (pharmacyId) {
			const url = '/user/createDriverUser';
			const data = {
				email: values.email,
				first_name: values.fullName,
				password: values.password,
				zip_code: values.zip,
				pharmacy_id: pharmacyId
			};

			sendData(url, data).then((response) => {
				if (Object.keys(response).length > 0) {
					Swal.fire({
						text: response['message'],
						icon: 'success',
						confirmButtonColor: '#128780'
					}).then(() => closeDriverModal());
				}
			});
		}
	};

	return (
		<Modal
			visible={showModal}
			onCancel={closeDriverModal}
			title={'Driver Details'}
			width={700}
			footer={[
				<Button key='back' onClick={closeDriverModal}>
					Cancel
				</Button>,
				<Button key='submit' type='primary' onClick={() => form.current.submit()}>
					Save
				</Button>
			]}
		>
			<Form
				layout='vertical'
				className='form'
				style={{ width: '100%' }}
				ref={form}
				onLoad={() => form.current.resetFields()}
				onFinish={handleSubmit}
			>
				<Row gutter={24}>
					<Col span={12}>
						<Form.Item
							label='Email'
							name='email'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='email' />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label='Password' name='password'>
							<Input size='large' type='password' />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col span={12}>
						<Form.Item
							label='Full Name'
							name='fullName'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='text' />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label='Zip Code'
							name='zip'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='text' />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
}

DriverModal.propTypes = {
	showModal: PropTypes.bool,
	closeDriverModal: PropTypes.func
};
